import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private _http: HttpClient, private _auth : AuthService) { }

  public model = 'users';

  login(data): Observable<User> {
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + '/authenticate';
    return this._http.post<User>(uri, data);
  }

  change(data: ChangePass): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + `/changePassword`;
    return this._http.put<any>(uri, data);
  }

  drop(data): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + `/forgotPassword?email=${data.email}`;
    return this._http.post<any>(uri, data);
  }

  create(data): Observable<UserPostPutGetId> {
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + '/registration';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.post<UserPostPutGetId>(uri, data, {headers: headers});
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('_tnu');
    // Check whether the token is expired and return
    // true or false
    return !!token;
  }
}

interface UserPostPutGetId {
  isVerified: string | number,
  roles: any,
  username: string,
  created_at: string,
  firstName: string,
  lastName: string,
  id?: string | number
}

interface ChangePass {
  password: string,
  restoreToken: string
}

interface User {
  createdDate: string
  firstName: string
  lastName: string
  token: string
  username: string
  _id: string
}